import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { FormatUtilities } from '../utilities/format-utilities';
import { UnitProgressDetail, ActivityResult, Encounter } from '../data/student-report';
import { BaseComponent } from '../base/base.component';
import { StudentProgressReportComponent } from '../student-progress-report/student-progress-report.component';
import { tap } from 'rxjs/operators';
import { json2csv } from 'json-2-csv';
import { FileUtilities } from '../utilities/file-utilities';
import { OrgUsageReport } from '../data/org-usage-report';
import { OrganizationDetail } from '../data/organization-detail';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { ISortOrder } from '../sort-toggle/sort-toggle.component';

@Component({
  selector: 'app-org-usage-report',
  templateUrl: './org-usage-report.component.html',
  styleUrls: ['./org-usage-report.component.scss']
})
export class OrgUsageReportComponent extends BaseComponent {
  // local variable for report
  rootReport: OrgUsageReport;
  activeReport: OrgUsageReport;
  organizationId: number;
  @Input() organizationDetail: OrganizationDetail;
  currentDate: Date = new Date();
  endDate = this.currentDate.toDateString();
  startDate = new Date(this.currentDate.setFullYear(this.currentDate.getFullYear() - 1)).toDateString();
  fetchingReport: boolean = false;
  fetchingCsv: boolean = false;
  
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.organizationId = params.organizationId;
      this.dataService.getOrganizationDetail(this.organizationId).subscribe(organizationDetail => {
        this.organizationDetail = organizationDetail;
        if(!this.userAuthorizedForReport()) {
          this.router.navigate([`/organizations/${this.organizationId}`]);
        }
      });
    });
    this.route.queryParams.subscribe(query => {
      if (query.end) {
        this.endDate = new Date(query.end).toDateString();
      }
      if (query.start) {
        this.startDate = new Date(query.start).toDateString();
      }
      if (query.end && query.start) {
        this.getRootOrgUsageReport();
      }
    })
  }

  showReport(): boolean {
    return this.activeReport !== undefined && !this.fetchingReport;
  }

  updateSort(sortOrder: ISortOrder) {
    this.activeReport.Suborgs.sort((a, b) => {
      var sortVal =
        sortOrder.orderBy === 'Total' ? (a.TotalStudents - b.TotalStudents) :
        sortOrder.orderBy === 'Time' ? (this.getAverageMinutes(a.ActiveStudents, a.TotalMinutes) - this.getAverageMinutes(b.ActiveStudents, b.TotalMinutes)) :
        sortOrder.orderBy === 'Active' ? (this.getActivePercent(a.ActiveStudents, a.TotalStudents) - this.getActivePercent(b.ActiveStudents, b.TotalStudents)) :
        sortOrder.orderBy === 'Teacher' ? ((a.TeacherName || "").localeCompare(b.TeacherName || "")) :
        sortOrder.orderBy === 'UnitTest' ? (this.getUnitTestPercent(a) - this.getUnitTestPercent(b)) :
        sortOrder.orderBy === 'SpeakingOpportunities' ? (a.SpeakingOpportunities - b.SpeakingOpportunities) :
        a.Name.localeCompare(b.Name);
      if (!sortOrder.ascending) sortVal *= -1;
      return sortVal;
    });
  }

  getRootOrgUsageReport(): void {
    this.fetchingReport = true;

    const deeplinkUrl = this.router.createUrlTree([], {relativeTo: this.route, queryParams: {start: this.startDate, end: this.endDate}}).toString();
    this.location.go(deeplinkUrl);

    this.dataService.getOrgUsageReport(this.organizationId, this.startDate, this.endDate).subscribe(o => {
      this.rootReport = o.find(report => report.OrganizationId == this.organizationId);
      this.rootReport.Parent = undefined;
      this.rootReport.Suborgs = o.filter(report => report.OrganizationId != this.organizationId);

      this.rootReport.Suborgs.forEach(suborg => suborg.Parent = this.rootReport);
      this.activeReport = this.rootReport;
      this.fetchingReport = false;
    });
  }

  navigateReportTree(newReport: OrgUsageReport) {
    this.activeReport = newReport;

    if (!newReport.Suborgs && !newReport.ClassId) {
      this.fetchingReport = true;
      this.dataService.getOrgUsageReport(newReport.OrganizationId, this.startDate, this.endDate).subscribe(o => {
        if (Array.isArray(o)) {
          newReport.Suborgs = o.filter(suborg => suborg.OrganizationId != this.activeReport.OrganizationId);
          newReport.Suborgs.forEach(suborg => suborg.Parent = newReport);
        }
        else {
          newReport.Suborgs = [];
        }
        this.fetchingReport = false;
      });
    }
    else if (newReport.ClassId) {
      this.fetchingReport = true;
      this.dataService.getClassReport(newReport.ClassId, this.startDate, this.endDate).subscribe(o => {
        newReport.ClassReport = o;
        this.fetchingReport = false;
      });
    }
  }

  downloadOrgUsageReport(): void {
    this.fetchingCsv = true;

    let orgID: number = this.activeReport && this.activeReport.OrganizationId ? this.activeReport.OrganizationId : this.organizationId;
    this.dataService.getFullOrgUsageReport(orgID, this.startDate, this.endDate).subscribe(o => {
      json2csv(o, (err, csv) => {
        console.log('converted to csv: ' + csv);
        let orgName: string = this.activeReport && this.activeReport.Name ? this.activeReport.Name : this.organizationDetail.Description;
        FileUtilities.saveFile(csv, this.generateReportFileName("JoySchoolEnglishUsageReport", orgName, "csv"), 'text/csv');
        this.fetchingCsv = false;
       });
    });
  }

  downloadCarrReport(): void {
    this.fetchingCsv = true;

    this.dataService.getCarrReport(this.organizationId, this.startDate, this.endDate).subscribe(o => {
      
      json2csv(o.DistrictSummary[0], (err, dsCSV) => {
        json2csv(o.LearningOpportunitiesTotal[0], (err, lotCSV) => {
          json2csv(o.LearningOpportunitiesAverage[0], (err, loaCSV) => {
            json2csv(o.StudentProgress, (err, spCSV) => {
              var report = "Carr Report";
              report += "\n";
              report += "\n";
              
              report += "District Summary";
              report += "\n";
              report += dsCSV;
              report += "\n";
              report += "\n";

              report += "Learning Opportunities Total";
              report += "\n";
              report += lotCSV;
              report += "\n";
              report += "\n";

              report += "Learning Opportunities Average";
              report += "\n";
              report += loaCSV;
              report += "\n";
              report += "\n";

              report += "StudentProgress";
              report += "\n";
              report += spCSV;

              FileUtilities.saveFile(report, this.generateReportFileName("CarrReport", this.organizationDetail.Description, "txt"), 'text/plain');
              this.fetchingCsv = false;
            });
          });
        });
      });

    });
  }

  downloadLicenseReport(): void {
    this.fetchingCsv = true;

    this.dataService.getLicenseReport(this.organizationId, this.startDate, this.endDate).subscribe(o => {
      json2csv(o, (err, dsCSV) => {
        FileUtilities.saveFile(dsCSV, this.generateReportFileName("LicenseReport", this.organizationDetail.Description, "txt"), 'text/plain');
        this.fetchingCsv = false;
      });
    });
  }

  isInternal(): boolean {
    return this.authService.isInternal();
  }

  generateReportFileName(baseName: string, orgName: string, fileExtension: string): string {
    orgName = orgName.replace(/\W/g, "");
    let downloadDate = this.currentDate.toISOString().substring(0,10).replace(/-/g, "");
    let fileName = `${baseName}-${orgName}-${downloadDate}.${fileExtension}`;

    return fileName;
  }

  userAuthorizedForReport(): boolean {
    if(this.organizationDetail.Permissions === undefined || this.organizationDetail.Permissions === null) return false;
    return this.organizationDetail.Permissions.some(p=>p.PermissionCode === 'ReadOrganizations');
  }

  formatDate(date: string){
    return FormatUtilities.longDateFormat(date);
  }

  roundUnitTestPercent(rawNumber: number): number {
    return Math.round(rawNumber * 100);
  }

  getUnitTestPercent(report: OrgUsageReport): number {
    return this.roundUnitTestPercent((report.UnitTestCorrect || 0) / (report.UnitTestTotal || 1));
  }

  getAverageMinutes(activeStudents: number, totalMinutes: number): number {
    if (!activeStudents) return 0;
    return Math.ceil(totalMinutes / activeStudents);
  }

  getActivePercent(active: number, total: number): number {
    if (!total) return 0;
    return Math.floor(1000 * active / total) / 10;
  }

  formatTimeSpent(minutes: number): string {
    if (!minutes) return "0 min";

    const hours = Math.floor(minutes / 60);
    const remainder = minutes % 60;

    let output = "";

    if (hours) output += `${hours} hr `;
    output += `${remainder} min`;

    return output;
  }
  
  showTeacherNames(): boolean {
    return this.activeReport.Suborgs.some(org => org.TeacherName);
  }

  allSuborgsAreClasses(): boolean {
    return this.activeReport.Suborgs.every(org => org.ClassId);
  }
}